export default function getTrainingType (value) {
  // Semua return wording telah sesuai dan di approved oleh Tim Data
  const trainingType = {
    0: 'Regular',
    1: 'Offline',
    2: 'Webinar',
    3: 'SPL'
  }
  return trainingType[value]
}
